__turbopack_context__.v({
  "body": "MonthYearSelect-module-scss-module__mQRnaa__body",
  "control": "MonthYearSelect-module-scss-module__mQRnaa__control",
  "error": "MonthYearSelect-module-scss-module__mQRnaa__error",
  "errorMsg": "MonthYearSelect-module-scss-module__mQRnaa__errorMsg",
  "label": "MonthYearSelect-module-scss-module__mQRnaa__label",
  "required": "MonthYearSelect-module-scss-module__mQRnaa__required",
  "root": "MonthYearSelect-module-scss-module__mQRnaa__root",
});
